import SmoothScroll from './smooth_scroll.js';
import Modal from './modal.js';

export default class Common {
  constructor() {
    this.init();
  }

  init() {
    this.modal = new Modal();
    this.SmoothScroll = new SmoothScroll();
  }
}
